import { afterNextRender, Component, OnInit } from '@angular/core';
import { map, Observable } from 'rxjs';
import { PublicAppSection } from '../../store/ui/ui.state';
import { Store } from '@ngrx/store';
import { fromStore } from '../../store';

@Component({
  selector: 'app-not-found',
  template: `
    <div class="container pt-10 text-center md:pt-20">
      <div class="mx-auto w-80 md:w-96">
        <dotlottie-wc
          autoplay
          loop
          src="/assets/img/404.json"
        ></dotlottie-wc>
      </div>
      <div class="text-center">
        <div class="-mt-8 text-6xl font-bold uppercase md:text-8xl">OUPS !</div>
        <div class="mt-4 text-lg font-bold uppercase md:text-2xl">
          Nous n'avons pas trouvé la page que vous cherchez.
        </div>
        <div class="mt-8">
          <app-button
            variant="primary"
            icon="arrow-left"
            [routerLink]="
              (B2C$ | async) ? ['/louer-salle', vendorSlug$ | async] : ['/']
            "
          >
            Retour
          </app-button>
        </div>
      </div>
    </div>
  `,
  standalone: false,
})
export class NotFoundPageComponent implements OnInit {
  B2C$: Observable<boolean> = this.store
    .select(fromStore.selectPublicAppSection)
    .pipe(
      map((publicAppSection: PublicAppSection) => {
        return publicAppSection === PublicAppSection.B2C;
      }),
    );
  vendorSlug$: Observable<string> = this.store.select(
    fromStore.selectVendorSlug,
  );

  constructor(private store: Store) {
    afterNextRender(() => {
      import('@lottiefiles/dotlottie-wc');
    });
  }

  ngOnInit(): void {}
}
